export default __webpack_public_path__ + "media/images/ui-icons_777777_256x240-961d6729.png";